import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';
import { routes } from '../RouterPath';

export const feedsBreadcrumbs = (brandName = '') : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Фиды',
        url: routes.feeds,
    },
    {
        key: '2',
        value: brandName,
        url: '',
    },
]);
